<template>
  <form class="form" :class="additionalClass">
    <slot />
  </form>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  export default defineComponent({
    name: 'FormWrapper',
    props: {
      additionalClass: {
        type: String,
        required: false,
        default: '',
      },
    },
  });
</script>
